<template>
    <edit-view-base :filter="filter" :has-card-view="false" :cards="cards" :tabs="tabs" :main-form="mainForm" :claim-name="claimName" :api-method="apiMethod" :item-id="itemId" :refresh-key="refreshKey" />
</template>

<script>
    export default {
        props: [
            'filter',
            'itemId',
            'refreshKey'
        ],

        components: {
            editViewBase: () => import('../components/EditViewBase')
        },

        data() {
            return {
                cards: [
                    { title: 'Test Group', apiMethod: 'TestGroups', form: () => import('../forms/TestGroupForm'), items: [], filter: {}, dialog: false, isVisible: true, isMainCard: true },
                ],
                tabs: [
                    { text: 'Tests', value: 'testGroupId', table: () => import('../tables/TestsTable') },
                ],
                mainForm: () => import('../forms/TestGroupForm'),
                claimName: 'TestGroups',
                apiMethod: 'TestGroups',
            }
        }
    };
</script>
